import React from 'react';
import { Box, LinearProgress } from '@mui/material';

const LoadingIndicator = () => (
  <Box sx={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%'
  }}>
    <LinearProgress
      variant="indeterminate"
      sx={{
        width: '300px',
        height: 6,
        borderRadius: '2px',
        backgroundColor: 'rgba(2, 28, 45, 0.1)',
        '& .MuiLinearProgress-bar': {
          backgroundColor: '#021C2D',
          borderRadius: '2px'
        }
      }}
    />
  </Box>
);

export default LoadingIndicator;
